export default __webpack_public_path__ + "static/media/notification.07ffba0a.png";